module.exports = __webpack_public_path__ + "img/banner-icon-warning.0fe6cde5.svg";